import React from 'react';
import {
    Typography,
    Card,
    Space,
    Switch,
    Alert,
    Grid
} from 'antd';
import { SettingOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../components/ThemeProvider';
import '../styles/NewsDetail.css';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const SettingsPage: React.FC = () => {
    const { token } = useAuth();
    const { isDark, toggleTheme } = useTheme();
    const screens = useBreakpoint();

    if (!token) {
        return (
            <div style={{ padding: screens.md ? '24px' : '16px', textAlign: 'center' }}>
                <Alert
                    message="Authentication Required"
                    description="Please log in to access settings."
                    type="info"
                    showIcon
                />
            </div>
        );
    }

    return (
        <div style={{
            padding: screens.md ? '24px' : '16px',
            maxWidth: screens.md ? '1000px' : '100%',
            margin: '0 auto'
        }}>
            <Space direction="vertical" size={screens.md ? "large" : "middle"} style={{ width: '100%' }}>
                <div>
                    <Title level={screens.md ? 3 : 4} style={{ marginBottom: '4px' }}>
                        <SettingOutlined /> Settings
                    </Title>
                    <Text type="secondary" style={{ fontSize: screens.md ? '14px' : '12px' }}>
                        Customize your application settings and preferences.
                    </Text>
                </div>

                {/* Appearance Settings */}
                <Card title="Appearance" style={{ marginBottom: '16px' }} size="small">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                            <Text strong>Dark Mode</Text>
                            <br />
                            <Text type="secondary" style={{ fontSize: '12px' }}>
                                Switch between light and dark themes
                            </Text>
                        </div>
                        <Switch
                            checkedChildren={<MoonOutlined />}
                            unCheckedChildren={<SunOutlined />}
                            checked={isDark}
                            onChange={toggleTheme}
                        />
                    </div>
                </Card>

                {/* Additional Settings sections can be added here */}
            </Space>
        </div>
    );
};

export default SettingsPage;
